export default __webpack_public_path__ + "4e7e5948468c6d5e1ded72d71e76ecee.svg";